<template>
  <div @click="irParaAvisosInbox" class="message-notificator-wrapper">
    <font-awesome-icon icon="envelope" size="2x" class="envelope-icon" />
    <b-badge variant="success" pill class="align-top custom-badge">{{unreadCount}}</b-badge>
  </div>
</template>

<script>
import { store } from "@/store";
import { Service } from '../../services/mainService'

export default {
  name: "MessageNotificator",
  data() {
    return {
      unreadCount: 0,
    };
  },
  methods: {
    async getMessagesBadge(){
      await Service.$http
        .get(process.env.VUE_APP_MESSAGES_API + "/avisos/qtdAvisosNaoLidos", {
          headers: { Authorization: "Bearer " + store.token },
        })
        .then((response) => {
          this.unreadCount = response.data
        })
        .catch((error) => {
          this.$toast.error((error.response.data.msg || error.message || error))
        })
    },
    irParaAvisosInbox(){
      this.$router.push('/mural-avisos');
    }
  },
  computed: {
    updateUnreadCount() {
      return store.token;
    }
  },
  watch: {
    updateUnreadCount(newVal, oldVal){
      if(newVal !== false && store.cpf !== ''){
        this.getMessagesBadge();
      }
    }
  },
  mounted() {
    this.$root.$on('updateUnreadCount', () => {
      this.getMessagesBadge()
    });
    if(store.primeiroAcesso == "N")
      this.getMessagesBadge()
  },
};
</script>
<style>
 .badge-success {
    background-color: var(--baseColor)!important;
  }

  .envelope-icon {
    color: var(--baseColor)!important;
  }

  .custom-badge {
    font-size: 14px !important;
    margin-left: -0.5rem !important;
    margin-top: -0.5rem !important;
  }

  .message-notificator-wrapper{
    cursor: pointer;
  }
</style>